document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('klaviyo-footer-form');
  if (!form) return;

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    const emailInput = form.querySelector('[type="email"]');
    const successMsg = document.getElementById('klaviyo-success');
    const errorMsg   = document.getElementById('klaviyo-error');
    const btnText    = document.getElementById('klaviyo-btn-text');

    errorMsg.hidden   = true;
    successMsg.hidden = true;

    if (!emailInput.value || !emailInput.checkValidity()) {
      errorMsg.hidden = false;
      return;
    }

    if (btnText) btnText.textContent = '…';

    try {
      const res = await fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=SUZu75',
        {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
            'revision': '2023-12-15'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                list_id: 'VMns6d',
                email: emailInput.value,
                custom_source: 'Footer BLOWN Beauty'
              }
            }
          })
        }
      );

      if (res.ok || res.status === 202) {
        successMsg.hidden = false;
        emailInput.value  = '';
        form.querySelector('[type="submit"]').hidden = true;
      } else {
        errorMsg.hidden = false;
        if (btnText) btnText.textContent = 'S\'inscrire';
      }
    } catch (err) {
      errorMsg.hidden = false;
      if (btnText) btnText.textContent = 'S\'inscrire';
      console.error('Klaviyo error:', err);
    }
  });
});